// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__6XmW0","containerItemsCenter":"Skeleton_containerItemsCenter__38wz9"};